var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsBoolean, IsEmail, IsOptional, IsString, ValidateNested } from 'class-validator';
/**
 * Refusal code when an address the office wants to give a login to already is
 * the login of a Person in the same office (#1826, #1754). Only the own office
 * gets this answer, with the holder named; an address held in another office
 * answers exactly like a free one.
 */
export const ADDRESS_HELD_IN_OFFICE = 'ADDRESS_HELD_IN_OFFICE';
/** The Person of the Active office whose login an address already is. */
export class AddressHolderDto {
    id;
    firstName;
    lastName;
    /**
     * Archiving keeps the login (TM-9381): an archived patient still holds the
     * address, and the office may restore them rather than create them again.
     */
    isArchived;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AddressHolderDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], AddressHolderDto.prototype, "firstName", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", Object)
], AddressHolderDto.prototype, "lastName", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], AddressHolderDto.prototype, "isArchived", void 0);
/**
 * Answer of `POST /users/create-by-therapist`. Creating never refuses an
 * address, since a Contact address may be shared; when it is the login of a
 * Person in the same office, `addressHolder` names them (#1826).
 */
export class CreatedPatientDto {
    id;
    addressHolder;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CreatedPatientDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsOptional(),
    ValidateNested(),
    Type(() => AddressHolderDto),
    __metadata("design:type", Object)
], CreatedPatientDto.prototype, "addressHolder", void 0);
/**
 * Body of `POST /users/login-address-holder`. A body rather than a query
 * parameter, so the address stays out of request logs.
 */
export class LoginAddressHolderLookupDto {
    address;
}
__decorate([
    Expose(),
    IsEmail(),
    __metadata("design:type", String)
], LoginAddressHolderLookupDto.prototype, "address", void 0);
/**
 * Answer of `POST /users/login-address-holder`: the Person of the asking office
 * whose login the address is, or `null`. A free address and one held only in
 * another office both answer `null` (#1750).
 */
export class LoginAddressHolderDto {
    holder;
}
__decorate([
    Expose(),
    IsOptional(),
    ValidateNested(),
    Type(() => AddressHolderDto),
    __metadata("design:type", Object)
], LoginAddressHolderDto.prototype, "holder", void 0);
/** Whether an API error is the `ADDRESS_HELD_IN_OFFICE` refusal. */
export function addressHeldInOfficeRefusal(data) {
    if (data &&
        typeof data === 'object' &&
        data.code === ADDRESS_HELD_IN_OFFICE &&
        typeof data.holder === 'object') {
        return data;
    }
    return null;
}
//# sourceMappingURL=address-holder.js.map